// ─── src/hooks/useCatalystWaitlist.ts ─────────────────────────────────────────

import { useMutation, useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import {
  deleteCatalystWaitlistEntry,
  getCatalystWaitlist,
  getCatalystWaitlistStats,
} from "../api/catalystWaitlist";
import type { CatalystWaitlistParams } from "../types/catalystWaitlist";

export const catalystWaitlistKeys = {
  all:   ["catalystWaitlist"] as const,
  list:  (p: CatalystWaitlistParams) => [...catalystWaitlistKeys.all, "list", p] as const,
  stats: () => [...catalystWaitlistKeys.all, "stats"] as const,
};

export const useCatalystWaitlist = (params: CatalystWaitlistParams) =>
  useQuery({
    queryKey:        catalystWaitlistKeys.list(params),
    queryFn:         () => getCatalystWaitlist(params),
    placeholderData: keepPreviousData,
    staleTime:       30_000,
  });

export const useCatalystWaitlistStats = () =>
  useQuery({
    queryKey:  catalystWaitlistKeys.stats(),
    queryFn:   getCatalystWaitlistStats,
    staleTime: 60_000,
  });

export const useDeleteCatalystWaitlistEntry = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteCatalystWaitlistEntry(id),
    onSuccess:  () => qc.invalidateQueries({ queryKey: catalystWaitlistKeys.all }),
  });
};
